export default __webpack_public_path__ + "static/media/Halborn.037090bb.png";